import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { SOCIETY_PORTAL } from "../../../../Routing/routes";

const EditSocietyProfile = () => {
    const navigate = useNavigate();

    // Form data state - replace with API call to fetch existing data
    const [formData, setFormData] = useState({
        profileInfo: {
            societyName: "Zipgrid Family",
            societyNameForSMS: "Family",
            brandName: "ZG",
            panNumber: "AAAAA0000A",
            tanNumber: "QWQWQ",
            payPin: "64657",
            spintlyOrgId: "2577",
            spintlyDeviceId: "8886",
            chequeInNameOf: "kashibhuvan 2",
            communityCurrency: "Rupees",
            profileImage: null
        },
        about: {
            description: "4B-01, Paragon Plaza, Lal Bahadur Shastri Marg, Kurla West, Mumbai, Maharashtra 400070",
            clubTiming: "-"
        },
        basicInfo: {
            builderName: "12718271982",
            complexType: "-",
            constructionStatus: "-",
            area: "MUMBAI",
            city: "Mumbai",
            state: "Maharashtra",
            pinCode: "400057"
        },
        associationInfo: {
            associationName: "asdasd",
            isRegistered: "Y",
            gstRegNo: "27AAFAM3538D1ZQ",
            brandName: "ZG",
            projectName: "Oberoi",
            localAuthorityRegNo: "-",
            propertyTaxNumber: "-"
        },
        contactInfo: {
            address: "220, NARIMANPOINT POINT, MUMBAI",
            website: "www.zipgrid.com",
            phone: "-",
            otherDetails: "-",
            email: "santsy@zip.com",
            supportEmail: "-",
            ccEmail: "-",
            bccEmail: "-"
        },
        specificDetails: {
            registrationData: "BOM/WA/GNL/(O)308/85-86)",
            dateOfRegistration: "2024-04-04",
            totalCarpetArea: "100000",
            areaOfPlot: "20000",
            constructionCostPerUnit: "Rs. Carpet areas/Sq. Ft.",
            totalWaterInlets: "12",
            valuePerShare: "50"
        }
    });

    const [profileImage, setProfileImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [errors, setErrors] = useState({});

    // Indian GSTIN: 15 chars — 2 digit state code + 10 char PAN + 1 entity code + 1 alphanum + 'Z' + 1 alphanum (checksum)
    const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

    const handleChange = (section, field, value) => {
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleGstChange = (raw) => {
        // Strip anything that isn't A-Z or 0-9, force uppercase, cap at 15 chars
        const cleaned = (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 15);
        handleChange("associationInfo", "gstRegNo", cleaned);

        let msg = '';
        if (cleaned.length === 0) {
            msg = '';
        } else if (cleaned.length < 15) {
            msg = `GSTIN must be 15 characters (${cleaned.length}/15)`;
        } else if (!GST_REGEX.test(cleaned)) {
            msg = 'Invalid GSTIN format. Example: 27AAFAM3538D1ZQ';
        }
        setErrors(prev => ({ ...prev, gstRegNo: msg }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // GSTIN is optional, but if provided it must match the format
        const gst = formData.associationInfo.gstRegNo;
        if (gst && !GST_REGEX.test(gst)) {
            setErrors(prev => ({
                ...prev,
                gstRegNo: 'Invalid GSTIN format. Example: 27AAFAM3538D1ZQ',
            }));
            return;
        }

        // TODO: API call to save data
        console.log("Form data:", formData);
        console.log("Profile image:", profileImage);
        navigate(SOCIETY_PORTAL + "/society-profile");
    };

    const handleCancel = () => {
        navigate(SOCIETY_PORTAL + "/society-profile");
    };

    // Reusable form section component
    const FormSection = ({ title, icon, children }) => (
        <div className="card radius-12 border mb-24">
            <div className="card-header bg-transparent py-16 px-24 d-flex align-items-center gap-12 border-bottom">
                <span
                    className="d-flex align-items-center justify-content-center radius-8"
                    style={{ width: "40px", height: "40px", backgroundColor: "#fef3c7" }}
                >
                    <Icon icon={icon} className="text-xl" style={{ color: "#f59e0b" }} />
                </span>
                <h6 className="text-lg fw-semibold mb-0">{title}</h6>
            </div>
            <div className="card-body p-24">
                {children}
            </div>
        </div>
    );

    // Reusable form input component
    const FormInput = ({ label, value, onChange, type = "text", placeholder = "", required = false, colSize = "col-md-4", error = "", maxLength }) => (
        <div className={`${colSize} mb-20`}>
            <label className="form-label fw-medium text-sm mb-8" style={{ color: "#374151" }}>
                {label} {required && <span className="text-danger">*</span>}
            </label>
            <input
                type={type}
                className="form-control radius-8 px-16 py-12"
                style={{ border: `1px solid ${error ? "#dc2626" : "#e5e7eb"}`, fontSize: "14px" }}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                required={required}
                maxLength={maxLength}
            />
            {error && (
                <small className="text-danger mt-4 d-block" style={{ fontSize: "12px" }}>
                    {error}
                </small>
            )}
        </div>
    );

    // Reusable textarea component
    const FormTextarea = ({ label, value, onChange, rows = 3, placeholder = "", colSize = "col-md-8" }) => (
        <div className={`${colSize} mb-20`}>
            <label className="form-label fw-medium text-sm mb-8" style={{ color: "#374151" }}>
                {label}
            </label>
            <textarea
                className="form-control radius-8 px-16 py-12"
                style={{ border: "1px solid #e5e7eb", fontSize: "14px" }}
                rows={rows}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );

    // Reusable select component
    const FormSelect = ({ label, value, onChange, options, colSize = "col-md-4" }) => (
        <div className={`${colSize} mb-20`}>
            <label className="form-label fw-medium text-sm mb-8" style={{ color: "#374151" }}>
                {label}
            </label>
            <select
                className="form-select radius-8 px-16 py-12"
                style={{ border: "1px solid #e5e7eb", fontSize: "14px" }}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            >
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );

    return (
        <>
            <form onSubmit={handleSubmit}>
                {/* Page Title with Action Buttons */}
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                    <h4 className="text-xl fw-semibold mb-0" style={{ color: "#374151" }}>
                        Edit Society Profile
                    </h4>
                    <div className="d-flex gap-12">
                        <button
                            type="button"
                            className="btn btn-outline-secondary px-20 py-10 radius-8"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn px-20 py-10 radius-8 text-white d-flex align-items-center gap-2"
                            style={{ backgroundColor: "#f59e0b" }}
                        >
                            <Icon icon="solar:diskette-line-duotone" className="text-lg" />
                            Save Changes
                        </button>
                    </div>
                </div>

                {/* Profile Image Section */}
                <div className="card radius-12 border mb-24">
                    <div className="card-header bg-transparent py-16 px-24 d-flex align-items-center gap-12 border-bottom">
                        <span
                            className="d-flex align-items-center justify-content-center radius-8"
                            style={{ width: "40px", height: "40px", backgroundColor: "#fef3c7" }}
                        >
                            <Icon icon="solar:camera-bold-duotone" className="text-xl" style={{ color: "#f59e0b" }} />
                        </span>
                        <h6 className="text-lg fw-semibold mb-0">Profile Image</h6>
                    </div>
                    <div className="card-body p-24">
                        <div className="d-flex align-items-center gap-24">
                            <div
                                className="d-flex align-items-center justify-content-center radius-12 overflow-hidden"
                                style={{
                                    width: "120px",
                                    height: "120px",
                                    backgroundColor: "#f3f4f6",
                                    border: "2px dashed #e5e7eb"
                                }}
                            >
                                {imagePreview ? (
                                    <img
                                        src={imagePreview}
                                        alt="Profile Preview"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                ) : (
                                    <Icon icon="solar:buildings-2-bold-duotone" className="text-5xl" style={{ color: "#9ca3af" }} />
                                )}
                            </div>
                            <div>
                                <label
                                    className="btn px-20 py-10 radius-8 text-white d-flex align-items-center gap-2"
                                    style={{ backgroundColor: "#f59e0b", cursor: "pointer" }}
                                >
                                    <Icon icon="solar:upload-line-duotone" className="text-lg" />
                                    Upload Image
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ display: "none" }}
                                    />
                                </label>
                                <p className="text-sm mt-8 mb-0" style={{ color: "#6b7280" }}>
                                    Recommended: 200x200px, JPG or PNG format
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Profile Information */}
                <FormSection title="Profile Information" icon="solar:user-id-bold-duotone">
                    <div className="row">
                        <FormInput
                            label="Society Name"
                            value={formData.profileInfo.societyName}
                            onChange={(val) => handleChange("profileInfo", "societyName", val)}
                            required
                        />
                        <FormInput
                            label="Society Name For SMS"
                            value={formData.profileInfo.societyNameForSMS}
                            onChange={(val) => handleChange("profileInfo", "societyNameForSMS", val)}
                        />
                        <FormInput
                            label="Brand Name"
                            value={formData.profileInfo.brandName}
                            onChange={(val) => handleChange("profileInfo", "brandName", val)}
                        />
                        <FormInput
                            label="PAN Number"
                            value={formData.profileInfo.panNumber}
                            onChange={(val) => handleChange("profileInfo", "panNumber", val)}
                        />
                        <FormInput
                            label="TAN Number"
                            value={formData.profileInfo.tanNumber}
                            onChange={(val) => handleChange("profileInfo", "tanNumber", val)}
                        />
                        <FormInput
                            label="Pay PIN"
                            value={formData.profileInfo.payPin}
                            onChange={(val) => handleChange("profileInfo", "payPin", val)}
                        />
                        <FormInput
                            label="Spintly Organisation ID"
                            value={formData.profileInfo.spintlyOrgId}
                            onChange={(val) => handleChange("profileInfo", "spintlyOrgId", val)}
                        />
                        <FormInput
                            label="Spintly Device ID"
                            value={formData.profileInfo.spintlyDeviceId}
                            onChange={(val) => handleChange("profileInfo", "spintlyDeviceId", val)}
                        />
                        <FormInput
                            label="Cheque In The Name of"
                            value={formData.profileInfo.chequeInNameOf}
                            onChange={(val) => handleChange("profileInfo", "chequeInNameOf", val)}
                        />
                        <FormSelect
                            label="Community Currency"
                            value={formData.profileInfo.communityCurrency}
                            onChange={(val) => handleChange("profileInfo", "communityCurrency", val)}
                            options={[
                                { value: "Rupees", label: "Rupees" },
                                { value: "USD", label: "USD" },
                                { value: "EUR", label: "EUR" }
                            ]}
                        />
                    </div>
                </FormSection>

                {/* About Section */}
                <FormSection title="About" icon="solar:info-circle-bold-duotone">
                    <div className="row">
                        <FormTextarea
                            label="Description"
                            value={formData.about.description}
                            onChange={(val) => handleChange("about", "description", val)}
                            rows={3}
                        />
                        <FormInput
                            label="Club Timing"
                            value={formData.about.clubTiming}
                            onChange={(val) => handleChange("about", "clubTiming", val)}
                        />
                    </div>
                </FormSection>

                {/* Basic Information */}
                <FormSection title="Basic Information" icon="solar:clipboard-text-bold-duotone">
                    <div className="row">
                        <FormInput
                            label="Builder Name"
                            value={formData.basicInfo.builderName}
                            onChange={(val) => handleChange("basicInfo", "builderName", val)}
                        />
                        <FormSelect
                            label="Complex Type"
                            value={formData.basicInfo.complexType}
                            onChange={(val) => handleChange("basicInfo", "complexType", val)}
                            options={[
                                { value: "-", label: "Select Type" },
                                { value: "Residential", label: "Residential" },
                                { value: "Commercial", label: "Commercial" },
                                { value: "Mixed", label: "Mixed" }
                            ]}
                        />
                        <FormSelect
                            label="Construction Status"
                            value={formData.basicInfo.constructionStatus}
                            onChange={(val) => handleChange("basicInfo", "constructionStatus", val)}
                            options={[
                                { value: "-", label: "Select Status" },
                                { value: "Under Construction", label: "Under Construction" },
                                { value: "Ready to Move", label: "Ready to Move" },
                                { value: "Completed", label: "Completed" }
                            ]}
                        />
                        <FormInput
                            label="Area"
                            value={formData.basicInfo.area}
                            onChange={(val) => handleChange("basicInfo", "area", val)}
                        />
                        <FormInput
                            label="City"
                            value={formData.basicInfo.city}
                            onChange={(val) => handleChange("basicInfo", "city", val)}
                        />
                        <FormInput
                            label="State"
                            value={formData.basicInfo.state}
                            onChange={(val) => handleChange("basicInfo", "state", val)}
                        />
                        <FormInput
                            label="Pin Code"
                            value={formData.basicInfo.pinCode}
                            onChange={(val) => handleChange("basicInfo", "pinCode", val)}
                        />
                    </div>
                </FormSection>

                {/* Association Information */}
                <FormSection title="Association Information" icon="solar:users-group-rounded-bold-duotone">
                    <div className="row">
                        <FormInput
                            label="Association Name"
                            value={formData.associationInfo.associationName}
                            onChange={(val) => handleChange("associationInfo", "associationName", val)}
                        />
                        <FormSelect
                            label="Is Registered"
                            value={formData.associationInfo.isRegistered}
                            onChange={(val) => handleChange("associationInfo", "isRegistered", val)}
                            options={[
                                { value: "Y", label: "Yes" },
                                { value: "N", label: "No" }
                            ]}
                        />
                        <FormInput
                            label="GST Registration No."
                            value={formData.associationInfo.gstRegNo}
                            onChange={handleGstChange}
                            placeholder="e.g. 27AAFAM3538D1ZQ"
                            maxLength={15}
                            error={errors.gstRegNo}
                        />
                        <FormInput
                            label="Brand Name"
                            value={formData.associationInfo.brandName}
                            onChange={(val) => handleChange("associationInfo", "brandName", val)}
                        />
                        <FormInput
                            label="Project Name"
                            value={formData.associationInfo.projectName}
                            onChange={(val) => handleChange("associationInfo", "projectName", val)}
                        />
                        <FormInput
                            label="Local Authority Registration No."
                            value={formData.associationInfo.localAuthorityRegNo}
                            onChange={(val) => handleChange("associationInfo", "localAuthorityRegNo", val)}
                        />
                        <FormInput
                            label="Property Tax Number"
                            value={formData.associationInfo.propertyTaxNumber}
                            onChange={(val) => handleChange("associationInfo", "propertyTaxNumber", val)}
                        />
                    </div>
                </FormSection>

                {/* Contact Information */}
                <FormSection title="Contact Information" icon="solar:phone-calling-bold-duotone">
                    <div className="row">
                        <FormTextarea
                            label="Address"
                            value={formData.contactInfo.address}
                            onChange={(val) => handleChange("contactInfo", "address", val)}
                            rows={2}
                        />
                        <FormInput
                            label="Website"
                            value={formData.contactInfo.website}
                            onChange={(val) => handleChange("contactInfo", "website", val)}
                            type="url"
                        />
                        <FormInput
                            label="Phone"
                            value={formData.contactInfo.phone}
                            onChange={(val) => handleChange("contactInfo", "phone", val)}
                            type="tel"
                        />
                        <FormInput
                            label="Email"
                            value={formData.contactInfo.email}
                            onChange={(val) => handleChange("contactInfo", "email", val)}
                            type="email"
                        />
                        <FormInput
                            label="Support Email"
                            value={formData.contactInfo.supportEmail}
                            onChange={(val) => handleChange("contactInfo", "supportEmail", val)}
                            type="email"
                        />
                        <FormInput
                            label="CC Email"
                            value={formData.contactInfo.ccEmail}
                            onChange={(val) => handleChange("contactInfo", "ccEmail", val)}
                            type="email"
                        />
                        <FormInput
                            label="BCC Email"
                            value={formData.contactInfo.bccEmail}
                            onChange={(val) => handleChange("contactInfo", "bccEmail", val)}
                            type="email"
                        />
                        <FormInput
                            label="Other Details"
                            value={formData.contactInfo.otherDetails}
                            onChange={(val) => handleChange("contactInfo", "otherDetails", val)}
                        />
                    </div>
                </FormSection>

                {/* Specific Details */}
                <FormSection title="Specific Details" icon="solar:settings-bold-duotone">
                    <div className="row">
                        <FormInput
                            label="Registration Data"
                            value={formData.specificDetails.registrationData}
                            onChange={(val) => handleChange("specificDetails", "registrationData", val)}
                        />
                        <FormInput
                            label="Date of Registration"
                            value={formData.specificDetails.dateOfRegistration}
                            onChange={(val) => handleChange("specificDetails", "dateOfRegistration", val)}
                            type="date"
                        />
                        <FormInput
                            label="Total Carpet Area (Sq. Ft.)"
                            value={formData.specificDetails.totalCarpetArea}
                            onChange={(val) => handleChange("specificDetails", "totalCarpetArea", val)}
                            type="number"
                        />
                        <FormInput
                            label="Area of Plot (Sq. Ft.)"
                            value={formData.specificDetails.areaOfPlot}
                            onChange={(val) => handleChange("specificDetails", "areaOfPlot", val)}
                            type="number"
                        />
                        <FormInput
                            label="Construction Cost Per Unit"
                            value={formData.specificDetails.constructionCostPerUnit}
                            onChange={(val) => handleChange("specificDetails", "constructionCostPerUnit", val)}
                        />
                        <FormInput
                            label="Total Number of Water Inlets"
                            value={formData.specificDetails.totalWaterInlets}
                            onChange={(val) => handleChange("specificDetails", "totalWaterInlets", val)}
                            type="number"
                        />
                        <FormInput
                            label="Value Per Share (Rs.)"
                            value={formData.specificDetails.valuePerShare}
                            onChange={(val) => handleChange("specificDetails", "valuePerShare", val)}
                            type="number"
                        />
                    </div>
                </FormSection>

                {/* Bottom Action Buttons */}
                <div className="d-flex justify-content-end gap-12 mb-24">
                    <button
                        type="button"
                        className="btn btn-outline-secondary px-24 py-12 radius-8"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn px-24 py-12 radius-8 text-white d-flex align-items-center gap-2"
                        style={{ backgroundColor: "#f59e0b" }}
                    >
                        <Icon icon="solar:diskette-line-duotone" className="text-lg" />
                        Save Changes
                    </button>
                </div>
            </form>
        </>
    );
};

export default EditSocietyProfile;
